import Circles from "assets/svg/pages/jobs/circles.svg";
import DotsIcon from "assets/svg/pages/jobs/dots.svg";
import LinesIcon from "assets/svg/pages/jobs/lines.svg";
import OutlineCircles from "assets/svg/pages/jobs/outline-circles.svg";
import OutlineDots from "assets/svg/pages/jobs/outline-dots.svg";
import WaveLines from "assets/svg/pages/jobs/wave-lines.svg";
import React, { FC } from "react";

interface Props {}

const Intro: FC<Props> = ({}) => {
  return (
    <section className="relative overflow-hidden">
      <img
        src="/images/pages/jobs/intro-bg.jpg"
        alt="فرصت های شغلی دادبانان"
        className="absolute z-[10] block h-full w-full object-cover lg:hidden"
        loading="lazy"
      />
      <div className="relative z-20 bg-[#F1F2F499] px-[4%] py-10 lg:py-32 lg:px-[12%]">
        <div className="grid grid-cols-12 lg:gap-10">
          <div className="relative col-span-12 hidden h-fit w-fit lg:col-span-5 lg:block">
            <DotsIcon className="absolute bottom-[-25px] right-[-25px] z-10" />
            <OutlineDots className="absolute bottom-[50px] right-[-80px] z-10 2xl:bottom-[100px]" />
            <WaveLines className="absolute top-[110px] right-[-50px] z-10" />
            <Circles className="absolute top-[-50px] right-[140px] z-10" />
            <OutlineCircles className="absolute top-[-70px] right-[-70px] z-10" />
            <img
              src="/images/pages/jobs/intro-img.png"
              alt="فرصت های شغلی دادبانان"
              className="relative z-20 w-full rounded-2xl"
              loading="lazy"
            />
          </div>
          <div className="col-span-12 lg:col-span-7">
            <h1 className="text-center text-xl font-bold md:text-3xl lg:text-right xl:text-4xl 2xl:mt-3">
              شغلی متناسب{" "}
              <span className="relative">
                با علاقه و مهارت خود
                <LinesIcon className="absolute -right-4 -bottom-2 w-48 md:w-full" />
              </span>
              ، پیدا کنید
            </h1>

            <p className="mt-10 w-full max-w-[700px] text-center text-sm font-bold text-blue-550 md:text-justify md:text-base xl:text-xl 2xl:mt-16">
              دادبانان با برگزاری آموزش‌های متناسب با بازار کار و توسعه
              مهارت‌های دانش‌پذیران خود و همچنین معرفی مستمر فرصت‌های شغلی به
              آن‌ها، تلاش می‌کند با حمایت از دانشجویان و فارغ التحصیلان دانشگاه،
              ماموریت خویش در{" "}
              <span className="text-yellow-550">"پیوند آموزش و اشتغال"</span>{" "}را
              محقق نماید.
            </p>
            <p className="mt-6 w-full max-w-[700px] text-center text-xs text-blue-550 md:text-right md:text-base 2xl:mt-12">
              <span className="font-bold">شغل ها</span> : مشاور حقوقی، مدیر
              حقوقی، کارشناس حقوقی، وکیل دادگستری، کارشناس ارشد حقوقی و
              قراردادها، سرپرست تیم حقوقی و کارآموز وکالت
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
